<template>
  <div>
    <div v-if="!NavSolid" :class="NavSolid ? ' ' : 'menu-area-body'" style="height: 5rem"></div>
    <div class="bg-light">
      <div class="container-custom">
        <div class="row py-5">
          <div class="card p-4 col-12 property-header-card" data-aos="fade-up">
            <!-- {{ this.item }} -->
            <DetailHeaderCard :dataPropiedad="item"></DetailHeaderCard>
          </div>
          <div class="col-lg-8">
           
            <ImgSingleProperty :propiedadImagen="item.Imagenes" class="mt-3"></ImgSingleProperty>
            <TabDetailSingleProperty :galeryVideos="item.Videos" :galeryImagen="item.Imagenes" :dataDetail="item"></TabDetailSingleProperty>
          </div>
          <div class="col-4 d-none d-lg-block bg-card rounded shadow sticky-div mt-3 p-3" style="height: 95vh; top: 1rem">
            <ContactInfo :propiedad="item" :agent="item.Agente_Id" botonTransparent="btn-light-primary" :clase="trasparemt"></ContactInfo>
            <filterHome :origen="'singleProperty'" botonTransparent="btn-light-primary" :clase="trasparemt"></filterHome>
          </div>
        </div>
        <div class="d-md-none">
          <div class="bg-card rounded shadow p-4 mt-3">
            <ContactInfo :propiedad="item"  :agent="item.Agente_Id" botonTransparent="btn-light-primary" clase="form-control"></ContactInfo>
            <filterHome :origen="'singleProperty'" botonTransparent="btn-light-primary" clase="form-control"></filterHome>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContactInfo from "../components/ContactInfo.vue";
import filterHome from "../components/filterHome.vue";
import ImgSingleProperty from "../components/ImgSingleProperty.vue";
import ProductVue from "../components/ProductProperties.vue";

import DetailHeaderCard from "../components/DetailHeaderCard.vue";
import contact from "../components/Contact.vue";
import TabDetailSingleProperty from "../components/TabDetailSingleProperty.vue";
import { resolveStoredPublicDomain } from "@/utils/publicDomainStorage";
import { getCanonicalPath } from "@/utils/propertyUrl";
import { applySeo, markPrerenderPending, markPrerenderReady } from "@/utils/seo";

export default {
  watch: {
    "$route.params.id": function (newId, oldId) {
      console.log("watch----------***>", newId);
      if (newId !== oldId) {
        this.id = newId;
        this.getData();
      }
    },
  },
  props: ["NavSolid"],
  components: { ProductVue, contact, filterHome, ImgSingleProperty, ContactInfo, DetailHeaderCard, TabDetailSingleProperty },
  data() {
    return {
      trasparemt: 0,
      id: null,
      tabs: ["ABOUT", "FEATURE", "GALLERY", "Location"],
      currentTab: "ABOUT",
      item: {
        Imagenes: [],
        Videos: [],
      },
    };
  },
  created() {
    try {
      this.id = this.$route.params.id;
      // alert(this.id);
      // let dataprop = JSON.parse(localStorage.getItem("proppreview")) || 0;
      // if (dataprop == 0) {
      //   this.id = this.$route.params.id;
      // } else {
      //   console.log("..", dataprop);
      //   this.id = dataprop.Id_propiedad;
      // }

      // this.id = this.$route.params.id;
      this.getData();
    } catch (error) {
      console.log("aqui el error -->", error);
    }
  },
  async mounted() {
    try {
     
    }
    catch (error) {
      console.log("aqui el error -->", error);
      this.$isLoading(false);
      
    }
    
  },
  methods: {
    resolvePublicDomain() {
      return resolveStoredPublicDomain(this.$domain);
    },
    async getData() {
      markPrerenderPending();
      try {
        // alert("cambio en id-->", this.id);

        this.item = { Imagenes: [], Videos: [] };
        const resolvedDomain = this.resolvePublicDomain();
        // Pasa el locale activo (?lang=es|en) para que el backend devuelva
        // el canonical con el prefijo /es/ o /en/ correspondiente. Sin este
        // param, el canonical viene sin prefix y el SPA dispara un
        // router.replace que puede romper la carga de datos.
        const currentLocale = this.$i18n && this.$i18n.locale ? this.$i18n.locale : 'es';
        // Guard: si el id no es numerico (p. ej. "properties" cuando la
        // ruta /:lang(es|en)/:id matchea con un path en ingles), no llamar
        // a la API. Quedarse en estado vacio sin romper la UI.
        if (this.id === undefined || this.id === null || this.id === '' || !/^\d+$/.test(String(this.id))) {
          this.item = { Imagenes: [], Videos: [] };
          markPrerenderReady();
          return;
        }
        let res = await this.$store.dispatch("get", {
          path: `Propiedades/public/get/${this.id}?domain=${encodeURIComponent(resolvedDomain)}&lang=${currentLocale}`,
        });
        console.log("ln-280-----", res);
        this.item = res;
        applySeo(this.item.seo);
        const canonicalPath = getCanonicalPath(this.item.seo?.canonical);
        if (canonicalPath && canonicalPath !== this.$route.path) {
          await this.$router.replace({
            path: canonicalPath,
            query: this.$route.query,
          });
        }
        if (this.item.Imagenes.length == 0) {
          let dataimg = { Url: null };
          this.item.Imagenes.push(dataimg);
        }
        this.$forceUpdate();
      } catch (error) {
        this.item = { Imagenes: [], Videos: [] };
        markPrerenderReady();
      }
    },
  },
};
</script>
<style scoped>

.property-header-card {
  /* Antes: min-height: 250px (desktop) / 500px (mobile). Cuando el
     DetailHeaderCard tenia poco contenido, quedaba un espacio blanco
     grande abajo de la card. Removido el min-height para que la card
     se ajuste al contenido real. */
  min-height: 0;
}

.footer-section .map-container iframe {
  border-radius: 5px;
}

.tab-menu {
  display: flex;
  padding: 0;
  margin: 0;
  list-style-type: none;
  background-color: var(--bg-card);
  border-bottom: 1px solid #ddd;
}

.tab-menu li {
  margin-right: 20px;
  padding: 10px 15px;
  cursor: pointer;
  color: #555;
  font-weight: bold;
}

.tab-menu li.active {
  color: var(--primary);
  border-bottom: 2px solid var(--primary);
}

.details {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
}

.details div {
  width: 45%;
  margin-bottom: 10px;
  font-size: 14px;
  color: #555;
}

.details div strong {
  color: #333;
}

.property-brief {
  margin-top: 20px;
  color: #555;
  font-size: 14px;
  line-height: 1.6;
}

.attachments {
  margin-top: 20px;
  font-size: 14px;
}

.attachments a {
  text-decoration: none;
  color: var(--primary);
  font-weight: bold;
}

.attachments i {
  margin-right: 5px;
}

.map-link {
  float: right;
  color: var(--primary);
  font-size: 14px;
  cursor: pointer;
  text-decoration: none;
}

.containerV {
  display: flex;
  flex-direction: column;
  /* Organiza en columna */
  justify-content: center;
  /* Centra verticalmente */
  align-items: center;
  /* Centra horizontalmente */
  /*gap: 10px; /* Espacio entre el texto y los botones */
  /* Altura total */
  /* border: 1px solid #ddd; */
}

/* width */
::-webkit-scrollbar {
  width: 10px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #fdfcfc;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #e9e9e9;
  border-radius: 10px;
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #e9e9e9;
}

.inner {
  max-width: 100%;
  margin: auto;
  padding-left: 15px;
  padding-right: 15px;
}

.scroll-container {
  position: relative;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  width: 100%;

  scroll-snap-type: mandatory;
  scroll-behavior: smooth;

  word-wrap: break-word !important;
  margin-bottom: 50px;
}

.scroll-container .scroll-section {
  display: inline-block;
  vertical-align: middle;

  /* white-space: nowrap; */
}

/*Slider X (different sized images)*/

.scroll-container.diff-size {
  scroll-snap-destination: 50% 0%;
  padding: 20px 0px;
  margin: 1%;
}

.scroll-container.diff-size .scroll-section {
  width: auto;
  height: 100%;
  margin-right: 15px;
  scroll-snap-coordinate: 50% 0%;
}

.scroll-container.diff-size .scroll-section:first-child {
  scroll-snap-coordinate: 0% 0%, 50% 0%;
  margin-left: 15px;
}

.scroll-container.diff-size .scroll-section:last-child {
  scroll-snap-coordinate: 50% 0%, 100% 0%;
}

.searchdiv {
  /* background-color:#fd306e !important; */
  /* background-color: black !important; */
  /* padding: 30px;
    box-shadow: 0px 0px 10px 2px rgba(0, 0, 0, 0.25);
    border-radius: 20px; */
}

.buttonsearch {
  background-color: #fd306e !important;
  color: white;
}

.inputSearch {
  border-color: #fd306e !important;
}

.carousel-item img {
  /* height:100vh!important ; */
}
</style>
